module.exports = __webpack_public_path__ + "static/media/am_perm_side_icon_inactive.b644d763.svg";